import * as R from 'ramda';

export function hasGuest(users) {
  return R.contains('111', users) || R.contains(111, users);
}
